"use client";

import Layout from "@/components/layout/Layout";
import useMetadataStore from "@/store/metadata.store";

export default function Home() {
  const { data } = useMetadataStore();

  return (
    <>
      <Layout
        pageId={"contacts-page"}
        activePage={"Contact Us"}
        pageTitle={"Contact Us"}
        headerStyle={1}
        footerStyle={1}
        headTitle={`Contact Us - ${data?.customer?.name ?? ""}`}
      >
        <section id="contacts-5" className="wide-80 contacts-section division">
          <div className="container">
            {/* CONTACT INFO
					============================================= */}
            <div className="row">
              <div className="col-xl-12">
                <div className="row">
                  {/* LOCATION */}
                  <div className="col-md-6">
                    <div className="cbox-5">
                      {/* Title */}
                      <h5 className="h5-lg">Location</h5>
                      <p>{data?.customer?.address}</p>
                      {/* Address */}
                    </div>
                  </div>
                  {/* WORKING HOURS */}
                  <div className="col-md-6">
                    <div className="cbox-5">
                      {/* Title */}
                      <h5 className="h5-lg">Contact Details</h5>
                      {/* Title */}

                      <p className="foo-email txt-500 mt-15">
                        <a href="mailto:admin@kuberpos.com">
                          {data?.customer?.email}
                        </a>
                      </p>
                      {data?.customer.contactNumber && (
                        <p>
                          <span role="presentation">
                            <a href="tel:+17898987234" className="text-warning">
                              +1 {data?.customer.contactNumber}
                            </a>
                          </span>
                        </p>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>{" "}
            {/* END CONTACT INFO */}
            {/* GOOGLE MAP
					============================================= */}
            <div className="row">
              <div className="col-md-12">
                <div id="gmap">
                  <div className="google-map" tabIndex={0} role="button">
                    <iframe
                      title="addressMap"
                      width={600}
                      height={450}
                      style={{ border: 0 }}
                      src={`https://maps.google.com/maps?q=${data?.customer.address}&t=&z=15&ie=UTF8&iwloc=&output=embed`}
                      allowFullScreen
                      aria-hidden="false"
                    />
                  </div>
                </div>
              </div>
            </div>{" "}
            {/* END GOOGLE MAP */}
          </div>{" "}
          {/* End container */}
        </section>{" "}
        {/* END CONTACTS-5 */}
      </Layout>
    </>
  );
}
